import { cache } from "../persistence/cache";
import defaults from "../../constants";

/**
 * @module web/store
 * @private
 */

const PROFILE_CATEGORY = "";
let profileCategory = null;

/**
 * Update the user profileCategory related data, by storing it in memory.
 * @param {Object} newProfileCategory - An object containing user profileCategory data obtained from a request through a backend call.
 * @public
 */
const update = function(newProfileCategory) {
  profileCategory = newProfileCategory;
};

/**
 * Returns the current user profileCategory related data object stored in memory, where it will be searched for.
 * @returns {Object} - A found stored profileCategory related data object or null if not found in memory.
 * @public
 */
const get = async function(self, sendMasterProfileDataInHeaders) {
  const _this = self;

  let cachedUser = null;

  if (sendMasterProfileDataInHeaders) {
    // for logged in
    if (_this.localCache && _this.localCache.auth) {
      cachedUser = await cache.get("user", { database: "auth" });
    }
    const user = cachedUser && cachedUser.user && cachedUser.user;
    if (user && user.profiles && user.profiles.length) {
      // FIX ME
      // get the desired profile category,rather than the master profile every time
      const masterProfile = user.profiles.find(item => item.isMasterProfile);
      profileCategory = masterProfile ? masterProfile.profileCategory : cachedUser.profileCategory;
    }
  } else {
    if (_this.localCache && _this.localCache.auth) {
      cachedUser = await cache.get("currentProfile", { database: "auth" });
    }

    if (cachedUser && cachedUser.profileCategory) {
      // FIX ME
      // get the desired profile category,rather than the master profile every time
      profileCategory = cachedUser.profileCategory;
    } else {
      cachedUser = await cache.get("user", { database: "auth" });
      profileCategory = cachedUser && cachedUser.profileCategory;
    }
  }

  // for guest, in case auth db in not used like web client
  if (!profileCategory) {
    const guestProfie = _this.guestProfie();
    profileCategory = guestProfie?.profileCategory || PROFILE_CATEGORY;
  }
  return profileCategory;
};

export default { update, get };
